import certaLogo from "main/src/images/login-logos/certa-logo.svg";
import dnbLogo from "main/src/images/login-logos/dnb-logo.svg";
import cialLogo from "main/src/images/login-logos/cial-logo.svg";
import sayariLogo from "main/src/images/login-logos/sayari-logo.svg";

const currentYear = new Date().getFullYear();

/**
 * Centralized configuration for all host identifier login configs
 *
 * This contains all partner-specific branding information including:
 * - Page titles for login pages
 * - Copyright text with current year
 * - Domain hostnames for each partner
 * - Static logo assets for anti-phishing
 */
export const hostIdentifierLoginConfig = {
  dnb: {
    title: "D&B Compass",
    copyright: `© Dun & Bradstreet, Inc. 2000 - ${currentYear}. All Rights Reserved.`,
    // Certa.in Alias
    hostnames: ["dnbcompass.com"],
    logo: dnbLogo
  },
  cial: {
    title: "CIAL D&B",
    copyright: `© ${currentYear} CIAL Dun & Bradstreet.`,
    hostnames: [
      // Certa.in Alias
      "cialsrm.com",
      // Certa.site Alias
      "cialsmp.com"
    ],
    logo: cialLogo
  },
  sayari: {
    title: "Sayari Guide",
    copyright: `© ${currentYear}, Sayari Analytics, LLC & Sayari Labs, Inc. All Rights Reserved.`,
    hostnames: [
      // Certa.in Alias
      "sayariguide.com",
      // Certa.site Alias
      "sayariguidestaging.com"
    ],
    logo: sayariLogo
  },
  certa: {
    title: "Certa",
    copyright: `© ${currentYear} Opinr, Inc. d/b/a Certa. All Rights Reserved.`,
    /** only hostnames required by additionalHosts config */
    hostnames: [
      // Certaqa.com
      "certa.link",
      "certahub.com"
    ],
    logo: certaLogo
  },
  /** This is only added for testing */
  test: {
    title: "Test",
    copyright: `© ${currentYear} Test`,
    hostnames: ["n1.certa.example"],
    logo: certaLogo
  }
};

export type HostIdentifier = keyof typeof hostIdentifierLoginConfig;

/** Hosts that need special handling for mixpanel, feedback */
export const additionalHosts = Object.values(hostIdentifierLoginConfig).flatMap(
  config => config.hostnames
);
